<template>
  <div class="permission-add">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="40px">
      <el-form-item label="商场" prop="mallIds">
        <el-select v-model="form.mallIds" placeholder="请选择商场" multiple filterable>
          <el-option v-for="item in mallListData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="账号" prop="username">
        <el-input v-model="form.username" placeholder="请输入账号" :disabled="id ? true : false" :maxLength="18" >
          <template slot="append" v-if="usernameSuffix">{{usernameSuffix}}</template>
        </el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-divider></el-divider>
      <div class="form-title">权限配置</div>
      <div class="catalogue-box">
        <div class="mulu">目录</div>
        <div class="list-box">
          <!-- 一级 -->
          <div class="one-item" v-for="(oneItem, oneIndex) in form.permissions" :key="oneItem.id">
            <div class="name-box">
              <div class="left">
                <span class="name">{{ oneItem.name }}</span>
                <span class="desc">{{ oneItem.desc }}</span>
                <span class="verify" v-if="oneItem.enabled && permiChildrenCheck.length && !permiChildrenCheck[oneIndex]">（子菜单不允许为空）</span>
              </div>
              <div class="switch">
                <el-form-item prop="">
                  <el-switch v-model="form.permissions[oneIndex].enabled" @change="(v) => onSwitchChange(v, oneIndex)"></el-switch>
                </el-form-item>
              </div>
            </div>
            <!-- 二级 -->
            <div class="two-box" :style="`${form.permissions[oneIndex].enabled && form.permissions[oneIndex].children ? `max-height: ${form.permissions[oneIndex].children.length * 90}px` : 'max-height: 0'}`">
              <div class="two-item" v-for="(twoItem, twoIndex) in oneItem.children" :key="twoItem.id">
                <div class="two-name-box">
                  <el-form-item label=" " label-width="0" prop="">
                    <el-checkbox @change="(v) => onTwoChange(v, oneIndex, twoIndex)" v-model="form.permissions[oneIndex].children[twoIndex].enabled" class="checkbox">{{twoItem.name}}</el-checkbox>
                  </el-form-item>
                </div>
                <!-- 三级 -->
                <div class="three-box">
                  <div class="three-item" v-for="(threeItem, threeIndex) in twoItem.children" :key="threeItem.id">
                    <el-form-item label=" " label-width="0" prop="">
                      <el-checkbox v-model="form.permissions[oneIndex].children[twoIndex].children[threeIndex].enabled" class="checkbox">{{threeItem.name}}</el-checkbox>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <div class="footer">
      <el-button @click="onClear" class="footer-btn mr20">取消</el-button>
      <el-button type="primary" @click="onSubmit" class="footer-btn" :loading="submitLoading">提交</el-button>
    </div>
    <Dialog title="账号/密码" :dialogShow="isShowPWDialog" :maskClose="false">
      <template>
        <div class="new-PW">
          <el-row class="row">
            <el-col :span="4" class="col col-title">账号：</el-col>
            <el-col :span="18" class="col">{{PWResult.username}}</el-col>
          </el-row>
          <el-row class="row">
            <el-col :span="4" class="col col-title">初始密码：</el-col>
            <el-col :span="18" class="col">
              <span>{{PWResult.password}}</span>
              <span class="hint">（随机生成）</span>
            </el-col>
          </el-row>
          <el-row class="dialog-footer">
            <el-button class="fun-btn mr20" @click="onCopyPW">复制</el-button>
            <el-button class="fun-btn" type="primary" @click="onClear">确定</el-button>
          </el-row>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { api_getPermissonList, api_getPermissonDetail, api_postPermissonAdd, api_putPermissonEdit } from '@/api/account'
import { api_getConfig } from '@/api/common'
import Dialog from '@/components/Dialog/index'
import {copytext} from '@/utils/index.js'
import aes from '@/common/aes.js'

export default {
  name: "permissionAdd",
  components: {
    Dialog
  },
  data() {
    const checkUserName = (rule, value, callback) => {
      const check = /^[\da-z]+$/i
      if (!value) {
        callback(new Error('请输入账号'))
      } else if (!check.test(value)) {
        callback(new Error('请输入字母或数字'))
      } else {
        callback()
      }
    }
    return {
      id: '',
      usernameSuffix: '@happay.test', // 账号后缀
      permissionList: [], // 权限配置list
      permiChildrenCheck: [], // 二级菜单是否有选中项
      isShowPWDialog: false, // 账号/密码 弹窗的显示隐藏
      PWResult: {}, // 创建账号的结果值
      activeNames: [],
      mallListData: [], // 商场数据
      submitLoading: false,
      form: {
        mallIds: [],
        permissions: []
      },
      rules: {
        mallIds: [{ required: true,  message: '请选择商场' }],
        username: [{ required: true, validator: checkUserName, trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名' }],
      }
    };
  },
  async created() {
    this.getConfig() // 获取config数据
    if (this.$route.query.id) {
      this.$route.meta.title = '编辑账号'
      this.id = this.$route.query.id
      this.getDetailDate() // 获取详情数据
    } else {
      this.$route.meta.title = '新增账号'
      this.getPermissonList() // 获取默认权限配置List数据
    }
  },
  methods: {
    // 获取账号后缀
    async getConfig() {
      let {tenant, mall=[]} = await api_getConfig(['tenant', 'mall'])
      this.usernameSuffix = tenant.suffix ? '@' + tenant.suffix : '' // 账号后缀
      this.mallListData = mall // 商场数据
    },

    // 获取权限配置List数据
    async getPermissonList() {
      let res = await api_getPermissonList()
      res.forEach(item => {
        item.enabled = false
        item.children && item.children.forEach((item2) => {
          item2.enabled = false
          item2.children && item2.children.forEach(item3 => {
            item3.enabled = false
          })
        })
      })
      console.log('res: ', res);
      this.form.permissions = res
    },

    // 获取详情数据
    async getDetailDate() {
      const {account={}, permissions=[], mallIds=[]} = await api_getPermissonDetail({id: this.$route.query.id})

      this.form = {
        ...this.form,
        mallIds,
        username: account.username.indexOf('@') >= 0 ? account.username.split('@')[0] : account.username,
        name: account.name,
        permissions
      }
    },

    // 一级菜单开关改变
    onSwitchChange(value, index) {
      if (!value) {
        this.form.permissions[index].children && this.form.permissions[index].children.forEach(item => {
          item.enabled = false
          item.children && item.children.forEach(item2 => {
            item2.enabled = false
          })
        })
      }
    },

    // 二级菜单权限改变
    onTwoChange(value, oneIndex, twoIndex) {
      this.form.permissions[oneIndex].children[twoIndex].children && this.form.permissions[oneIndex].children[twoIndex].children.forEach(item => {
        item.enabled = value
      })
    },

    // 判断二级菜单至少勾选一项
    checkChildren() {
      this.permiChildrenCheck = []
      this.form.permissions.forEach((item, index) => {
        let flag = true
        if (item.children) {
          let enabled = !item.enabled || item.children[0].type === 'Button'
          !enabled && item.children.forEach((item2) => {
            !enabled && item2.enabled && (enabled = true)
          })
          flag = enabled
        }
        this.permiChildrenCheck.push(flag)
      })
      return this.permiChildrenCheck.indexOf(false) >= 0
    },

    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let params = {
            ...this.form,
          }

          console.log('params', params);
          if (this.checkChildren()) {
            this.$baseConfirm(
              '子菜单不允许为空，请勾选再提交',
              { title: '温馨提示', type: 'warning', },
            )
            return
          }

          this.submitLoading = true
          if (this.$route.query.id) {
            delete params.username
            params.id = this.$route.query.id
            try {
              await api_putPermissonEdit(params)
              this.$baseMessage('操作成功', 'success')
              this.onClear()
              this.submitLoading = false
            } catch {
              this.submitLoading = false
            }
          } else {
            try {
              const res = await api_postPermissonAdd(params)
              this.$baseMessage('新增账号成功', 'success')
              this.PWResult = {
                username: res.username || '',
                password: aes.decrypt(res.password)
              }
              this.isShowPWDialog = true
              this.submitLoading = false
            } catch {
              this.submitLoading = false
            }
          }
        }
      })
    },

    // 点击复制密码按钮
    onCopyPW() {
      const str = `账号：${this.PWResult.username}   密码：${this.PWResult.password}`
      const result = copytext(str)
      result && this.$baseMessage('复制成功', 'success')
    },

    // 点击复制密码弹窗的遮罩层
    onPWDialogMask() {
      this.isShowPWDialog = true
      return
    },

    // 点击取消按钮
    onClear() {
      this.$router.back(-1)
    },
  },
  watch: {
    isShowPWDialog: {
      handler(newValue) {
        if (!newValue) {
          this.PWResult = {}
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.permission-add {
  padding: 35px 20px;
  padding-bottom: 100px;
  position: relative;

  .form-title {
    font-size: 16px;
    color: #333333;
    font-weight: 500;
    margin-bottom: 20px;
  }

  .catalogue-box {
    padding: 0 32px;

    .mulu {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
    }

    .list-box {

      .one-item {

        .name-box {
          height: 40px;
          margin-top: 12px;
          border-bottom: 1px solid #cccccc;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .left {
            .name {
              font-size: 14px;
              font-weight: 500;
              color: #333333;
            }

            .desc {
              font-size: 12px;
              color: #999999;
              margin-left: 10px;
            }

            .verify {
              font-size: 12px;
              margin-left: 10px;
              color: #F74A4A;
            }
          }

          .switch {

            .el-form-item {
              margin: 0;
            }
          }

        }

        .two-box {
          padding-left: 56px;
          overflow: hidden;

          .two-item {

            .two-name-box {
              height: 40px;
              line-height: 40px;
              margin-top: 10px;
            }

            .three-box {
              margin-left: 28px;
              border-bottom: 1px solid #ccc;
              display: flex;
              justify-content: flex-start;

              .three-item {
                width: 134px;
                height: 40px;
                display: flex;
                align-items: center;

                .el-form-item {
                  margin: 0;
                }
              }
            }
          }
        }
      }
    }
  }

  .el-input,
  .el-select {
    width: 400px;
  }
  .checkbox {
    width: 20%;
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
    z-index: 999;
  }

  .footer-btn {
    width: 110px;
    height: 40px;
    border-radius: 2px;
  }

  .new-PW {
    margin-top: 50px;

    .row  {
      height: 50px;
      line-height: 50px;

      .col {
        font-size: 16px;
        color: #333333;
      }

      .col-title {
        text-align: right;
        margin-right: 20px;
      }

      .hint {
        font-size: 12px;
        color: #666666;
      }
    }

    .dialog-footer {
      position: absolute;
      left: 0;
      right: 30px;
      bottom: 30px;
      text-align: right;
    }
  }
}
</style>
